import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  dialogPaper: {
    maxWidth: 320
  },
  dialogTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  dialogContent: {
    paddingTop: 0,
    paddingBottom: 0
  },
  actionButton: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  discard: {
    color: theme.palette.warning.dark
  },
  confirm: {
    color: theme.palette.secondary.dark
  }
}));
